'use client';

import Flex from '@/components/Flex';
import cx from 'classnames';
import { useState } from 'react';

import styles from './CustomTextField.module.scss';
import { EBorderRadius, ICustomTextField } from './CustomTextField.types';
import { CustomIcon } from '../CustomIcon';
import { CustomInput } from './components/CustomInput.component';
import { CustomTextarea } from './components/CustomTextarea.component';
import { ExclamationCircleSVG } from './components/ExclamationCircleSVG';

export const CustomTextField: React.FC<ICustomTextField> = ({
  prevObject = null,
  prevIcon,
  postIcon,
  onIconClick,
  className,
  inputRef,
  textareaRef,
  isTextarea = false,
  borderRadius = EBorderRadius.DEFAULT,
  darker = false,
  error = null,
  small = false,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const textfieldClass = cx(styles.field, className, {
    [styles.rounded]: borderRadius === EBorderRadius.ROUNDED,
    [styles.square]: borderRadius === EBorderRadius.SQUARE,
    [styles.focused]: isFocused,
    [styles.hasError]: error,
    [styles.darker]: darker,
    [styles.isTextarea]: isTextarea,
    [styles.small]: small,
    [styles.disabled]: props.disabled,
  });

  return (
    <Flex flexDirection="column" className={styles.container}>
      <Flex flexDirection="row" alignItemsCenter className={textfieldClass}>
        {prevObject && <div className={styles.prevObject}>{prevObject}</div>}
        {prevIcon && (
          <CustomIcon
            icon={prevIcon}
            className={cx(styles.icon, styles.prevIcon, {
              [styles.clickable]: onIconClick && !props.disabled,
            })}
            {...(!props.disabled ? { onClick: onIconClick } : {})}
          />
        )}
        {isTextarea ? (
          <CustomTextarea
            ref={textareaRef}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            {...props}
          />
        ) : (
          <CustomInput
            ref={inputRef}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            {...props}
          />
        )}
        {postIcon && (
          <CustomIcon
            icon={postIcon}
            className={cx(styles.icon, styles.postIcon, {
              [styles.clickable]: onIconClick && !props.disabled,
            })}
            {...(!props.disabled ? { onClick: onIconClick } : {})}
          />
        )}
      </Flex>
      {error && (
        <div className={styles.errorMessage}>
          <ExclamationCircleSVG />
          {error}
        </div>
      )}
    </Flex>
  );
};
